import React from "react";
import { useAuth } from "@/App";
import PivotTableWidget from "@/components/PivotTableWidget";

const HomePage = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6" data-testid="home-page">
      {/* Pivot Table Widget - Full Width */}
      {(user?.account_type === 'master_admin' || user?.account_type === 'admin') && (
        <div className="w-full">
          <PivotTableWidget />
        </div>
      )}
    </div>
  );
};

export default HomePage;